export default __webpack_public_path__ + "static/media/GrangeJohnson-min.85b41c76.jpg";